import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  TextField,
  Button,
  Typography,
  Divider,
  CircularProgress,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { UploadOutlined, FilePdfOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import axios from "axios";
import { URL } from "../config";

const AddProductModal = ({ onClose, product, refresh }) => {
  const [loading, setLoading] = useState(false);
const normalizeArray = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  return [];
};


  const [selectedService, setSelectedService] = useState("");
  const [selectedCameraBrand, setSelectedCameraBrand] = useState("");
  const [selectedCameraType, setSelectedCameraType] = useState("");
  const [selectedIntercomm, setSelectedIntercomm] = useState("");
  const [selectedWired, setSelectedWired] = useState("");

  const [servicesList, setServicesList] = useState([]);
const [cameraBrandsList, setCameraBrandsList] = useState([]);
const [cameraTypeList, setCameraTypeList] = useState([]);
const [intercommList, setIntercommList] = useState([]);
const [wiredList, setWiredList] = useState([]);


  const [formData, setFormData] = useState({
    productName: "",
    productDescription: "",
    productAmount: "", 
      productDiscount: "",    
  productFinalPrice: "",   
  });

  const [imageFile, setImageFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [pdfPreview, setPdfPreview] = useState("");

 useEffect(() => {
  fetchServices();
  fetchWiredMasters();
}, []);


 useEffect(() => {
  if (!selectedService || !Array.isArray(servicesList)) return;

  const selectedServiceObj = servicesList.find(
    (s) => s.serviceId === selectedService
  );

  if (!selectedServiceObj) return;

  if (selectedServiceObj.serviceName === "Camera") {
    fetchCameraBrands();
    fetchCameraTypes();
  }

  if (selectedServiceObj.serviceName === "Intercomm") {
    fetchIntercomm();
  }
}, [selectedService, servicesList]);


 useEffect(() => {
  if (!product) return;

  setFormData({
    productName: product.productName || "",
    productDescription: product.productDescription || "",
    productAmount: product.productAmount || "",
    productDiscount: product.productDiscount || "",
    productFinalPrice: product.productFinalPrice || "",
  });

  setSelectedService(product.fkserviceId || "");
  setSelectedCameraBrand(product.fkcameraBrandId || "");
  setSelectedCameraType(product.fkcameraTypeId || "");
  setSelectedIntercomm(product.fkintercommId || "");
  setSelectedWired(product.fkwiredId || "");

  setImagePreview(product.productImg ? `${URL}${product.productImg}` : "");
  setPdfPreview(product.productPdf ? `${URL}${product.productPdf}` : "");
}, [product]);


  useEffect(() => {
  const amount = Number(formData.productAmount);
  const discount = Number(formData.productDiscount);

  if (!isNaN(amount) && !isNaN(discount)) {
    const finalPrice = amount - (amount * discount) / 100;
    setFormData((prev) => ({
      ...prev,
      productFinalPrice: Math.round(finalPrice),
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      productFinalPrice: "",
    }));
  }
}, [formData.productAmount, formData.productDiscount]);


const fetchServices = async () => {
  try {
    const res = await axios.get(`${URL}/services`);
    setServicesList(normalizeArray(res.data));
  } catch {
    toast.error("Failed to load services");
  }
};


const fetchCameraBrands = async () => {
  try {
    const res = await axios.get(`${URL}/camerabrands`);
    setCameraBrandsList(normalizeArray(res.data));
  } catch {
    toast.error("Failed to load camera brands");
  }
};


 const fetchCameraTypes = async () => {
  try {
    const res = await axios.get(`${URL}/cameratypes`);
    setCameraTypeList(normalizeArray(res.data));
  } catch {
    toast.error("Failed to load camera types");
  }
};


 const fetchIntercomm = async () => {
  try {
    const res = await axios.get(`${URL}/intercomms`);
    setIntercommList(normalizeArray(res.data));
  } catch {
    toast.error("Failed to load intercomms");
  }
};


const fetchWiredMasters = async () => {
  try {
    const res = await axios.get(`${URL}/wiredmasters`);
    setWiredList(normalizeArray(res.data));
  } catch {
    toast.error("Failed to load wired options");
  }
};


  const handleServiceChange = (serviceId) => {
    setSelectedService(serviceId);
    setSelectedCameraBrand("");
    setSelectedCameraType("");
    setSelectedIntercomm("");
    setSelectedWired("");
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleCameraCheckbox = (cameraTypeId) => {
    setSelectedCameraType((prev) => (prev === cameraTypeId ? "" : cameraTypeId));
  };

  const handleWiredCheckbox = (wiredId) => {
    setSelectedWired((prev) => (prev === wiredId ? "" : wiredId));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file?.type.startsWith("image/")) {
      toast.error("Only image files allowed!");
      return;
    }
    setImageFile(file);
    setImagePreview(window.URL.createObjectURL(file));
  };

  const handlePdfChange = (e) => {
    const file = e.target.files[0];
    if (!file || file.type !== "application/pdf") {
      toast.error("Only PDF files allowed!");
      return;
    }
    setPdfFile(file);
    setPdfPreview(file.name);
  };

  const handleSave = async () => {
    if (
      !formData.productName ||
      !formData.productDescription ||
      !selectedService
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);
    try {
      const formPayload = new FormData();

      formPayload.append("productName", formData.productName);
      formPayload.append("productDescription", formData.productDescription);
    formPayload.append("productAmount", formData.productAmount ?? "");
formPayload.append("productDiscount", formData.productDiscount ?? "");
formPayload.append("productFinalPrice", formData.productFinalPrice ?? "");


      formPayload.append("fkserviceId", selectedService);
      formPayload.append("fkcameraBrandId", selectedCameraBrand);
      formPayload.append("fkcameraTypeId", selectedCameraType);
      formPayload.append("fkintercommId", selectedIntercomm);
      formPayload.append("fkwiredId", selectedWired);

      if (imageFile) formPayload.append("productImg", imageFile);
      if (pdfFile) formPayload.append("productPdf", pdfFile);

      if (product) {
        await axios.put(`${URL}/products/${product.productId}`, formPayload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Product updated successfully!");
      } else {
        await axios.post(`${URL}/products`, formPayload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Product added successfully!");
      }

      refresh?.();
      onClose?.();
    } catch (err) {
      toast.error("Failed to save product");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      minHeight: "28px",
      fontSize: "14px",
      "& fieldset": { borderColor: "#c4c4c4" },
      "&:hover fieldset": { borderColor: "#184459ff" },
      "&.Mui-focused fieldset": {
        borderColor: "#c4c4c4",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "18px",
      color: "#184459ff",
      fontWeight: 600,
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#184459ff" },
  };

  const selectedServiceObj = servicesList.find(
    (s) => s.serviceId === selectedService
  );
  const isCamera = selectedServiceObj?.serviceName === "Camera";
  const isVDP = selectedServiceObj?.serviceName === "VDP";
  const isIntercomm = selectedServiceObj?.serviceName === "Intercomm";

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        p: 2,
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", sm: 450 },
          bgcolor: "#fff",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          maxHeight: "90vh",
        }}
      >
        <Box sx={{ p: 3 }}>
          <Typography
            variant="h6"
            textAlign="center"
            sx={{ color: "#184459ff" }}
          >
            {product ? "Edit Product" : "Add Product"}
          </Typography>
          <Divider sx={{ mt: 1 }} />
        </Box>

        <Box sx={{ flex: 1, overflowY: "auto", px: 3, py: 2 }}>
          <Stack spacing={2}>
            <TextField
              select
              label="Select Service"
              size="small"
              fullWidth
              value={selectedService}
              onChange={(e) => handleServiceChange(e.target.value)}
              sx={fieldStyle}
              InputLabelProps={{ shrink: true }}
            >
             {servicesList.map((s) => (
  <MenuItem key={s.serviceId} value={s.serviceId}>
    {s.serviceName}
  </MenuItem>
))}

            </TextField>

            {isCamera && (
              <TextField
                select
                label="Camera Brand"
                size="small"
                fullWidth
                value={selectedCameraBrand}
                onChange={(e) => setSelectedCameraBrand(e.target.value)}
                sx={fieldStyle}
                InputLabelProps={{ shrink: true }}
              >
                {cameraBrandsList.map((c) => (
                  <MenuItem key={c.cameraBrandId} value={c.cameraBrandId}>
                    {c.cameraBrandName}
                  </MenuItem>
                ))}
              </TextField>
            )}

            {isCamera && (
              <Box>
                <Typography fontWeight={600} mb={1}>
                  Camera Option
                </Typography>
                {cameraTypeList.map((c) => (
                  <FormControlLabel
                    key={c.CameraTypeId}
                    control={
                      <Checkbox
                        checked={selectedCameraType === c.CameraTypeId}
                        onChange={() => handleCameraCheckbox(c.CameraTypeId)}
                      />
                    }
                    label={c.CameraTypeName}
                  />
                ))}
              </Box>
            )}

            {(isCamera &&
              selectedCameraType &&
              cameraTypeList.find(
                (c) => c.CameraTypeId === selectedCameraType
              )?.CameraTypeName === "Wired") ||
            isVDP ? (
              <Box>
                <Typography fontWeight={600} mb={1}>
                  Wired Option
                </Typography>
                {wiredList.map((w) => (
                  <FormControlLabel
                    key={w.wiredId}
                    control={
                      <Checkbox
                        checked={selectedWired === w.wiredId}
                        onChange={() => handleWiredCheckbox(w.wiredId)}
                      />
                    }
                    label={w.wiredName}
                  />
                ))}
              </Box>
            ) : null}

            {isIntercomm && (
              <TextField
                select
                label="Select Intercomm"
                size="small"
                fullWidth
                value={selectedIntercomm}
                onChange={(e) => setSelectedIntercomm(e.target.value)}
                sx={fieldStyle}
                InputLabelProps={{ shrink: true }}
              >
                {intercommList.map((i) => (
                  <MenuItem key={i.intercommId} value={i.intercommId}>
                    {i.intercommName}
                  </MenuItem>
                ))}
              </TextField>
            )}

            <TextField
              label="Product Name"
              fullWidth
              size="small"
              value={formData.productName}
              onChange={(e) => handleChange("productName", e.target.value)}
              sx={fieldStyle}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              label="Product Description"
              multiline
              size="small"
              rows={3}
              fullWidth
              value={formData.productDescription}
              onChange={(e) =>
                handleChange("productDescription", e.target.value)
              }
              sx={fieldStyle}
              InputLabelProps={{ shrink: true }}
            />

            {/* NEW FIELD - PRODUCT AMOUNT */}
            <TextField
              label="Product Amount"
              type="number"
              fullWidth
              size="small"
              value={formData.productAmount}
              onChange={(e) =>
                handleChange("productAmount", e.target.value)
              }
              sx={fieldStyle}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
  label="Product Discount (%)"
  type="number"
  fullWidth
  size="small"
  value={formData.productDiscount}
  onChange={(e) =>
    handleChange("productDiscount", e.target.value)
  }
  sx={fieldStyle}
  InputLabelProps={{ shrink: true }}
/>
<TextField
  label="Final Price"
  type="number"
  fullWidth
  size="small"
  value={formData.productFinalPrice}
  disabled
  sx={{
    ...fieldStyle,
    "& input": { fontWeight: 700, color: "#184459ff" },
  }}
  InputLabelProps={{ shrink: true }}
/>


            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                border: "1px solid #c4c4c4",
                p: 1.5,
                borderRadius: 2,
              }}
            >
              <Button component="label" startIcon={<UploadOutlined />}>
                Upload Image
                <input
                  hidden
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </Button>

              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="img"
                  style={{ width: 50, height: 50, borderRadius: 8 }}
                />
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                border: "1px solid #c4c4c4",
                p: 1.5,
                borderRadius: 2,
              }}
            >
              <Button component="label" startIcon={<FilePdfOutlined />}>
                Upload PDF
                <input
                  hidden
                  type="file"
                  accept="application/pdf"
                  onChange={handlePdfChange}
                />
              </Button>

              {pdfPreview && (
                <Typography
                  sx={{
                    maxWidth: "250px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {pdfPreview}
                </Typography>
              )}
            </Box>
          </Stack>
        </Box>

        <Box sx={{ p: 3, borderTop: "1px solid #c4c4c4" }}>
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#184459ff" }}
              onClick={handleSave}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : product ? "Update Product" : "Add Product"}
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#757575ff" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default AddProductModal;
